import type { JSX } from "react";

import { cn } from "@/shared/lib/cn";

interface AllocationCellProps {
  value: number;
  className?: string;
}

export function AllocationCell({ value, className }: AllocationCellProps): JSX.Element {
  return (
    <span
      className={cn("num", value < 0 && "text-[var(--intent-danger-fg)] font-semibold", className)}
      data-testid="allocation-cell"
      data-negative={value < 0}
    >
      {value.toLocaleString()}
    </span>
  );
}
